import upsellService from '@/services/UpsellService'

export const upsell = () => {
  return {
    namespaced: true,
    state: {
      loading: false,
      products: [],
      product: undefined
    },
    mutations: {
      SET_LOADING (state, loading) {
        state.loading = loading
      },
      SET_PRODUCTS (state, products) {
        state.products = products
      },
      SET_PRODUCT (state, product) {
        state.product = product
      }
    },
    actions: {
      getUpsellProducts ({ commit }) {
        commit('SET_LOADING', true)

        return upsellService.getUpsellProducts()
          .then(response => {
            commit('SET_PRODUCTS', response.products)
          })
          .finally(() => {
            commit('SET_LOADING', false)
          })
      },
      getUpsellProduct ({ commit }, payload) {
        commit('SET_LOADING', true)

        return upsellService.getUpsellProduct(payload)
          .then(response => {
            commit('SET_PRODUCT', response.product)
          })
          .finally(() => {
            commit('SET_LOADING', false)
          })
      },
      addProductToRoomBill ({ commit }, payload) {
        commit('SET_LOADING', true)

        return upsellService.addProductToRoomBill(payload)
          .finally(() => commit('SET_LOADING', false))
      }
    }
  }
}
